import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { useRouter, Redirect } from '@atlassian/react-resource-router';

export const OnCallRedirect = () => {
	const [routeContext] = useRouter();
	const redirectionUrl = `${routeContext.location.pathname}/on-call`;
	return <Redirect to={redirectionUrl} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOnCall = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-on-call", jiraSpaEntry: "async-jira-eoc-on-call" */ '@atlassian/jira-eoc-on-call'
		),
);

const AsyncOnCall = (): React.JSX.Element => (
	<LazyPage Page={LazyOnCall} pageId="async-jira-eoc-on-call" shouldShowSpinner={false} />
);

export default AsyncOnCall;
